import { render, staticRenderFns } from "./DocumentRejectionModal.vue?vue&type=template&id=84c1075a&scoped=true&"
import script from "./DocumentRejectionModal.vue?vue&type=script&lang=js&"
export * from "./DocumentRejectionModal.vue?vue&type=script&lang=js&"
import style0 from "./DocumentRejectionModal.vue?vue&type=style&index=0&id=84c1075a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c1075a",
  null
  
)

export default component.exports